var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links"},_vm._l((_vm.links),function(link){return _c('div',{key:link.title,staticClass:"link"},[_c('div',{staticClass:"icon"},[_c('NbIcon',{attrs:{"icon":"plus","attributes":{
          'stroke-width': 3,
          width: '1.1rem',
          height: '1.1rem',
        }}})],1),_c('div',[_c('h4',{staticClass:"heading-4"},[_vm._v(_vm._s(link.title))]),_c('p',{staticClass:"body-3"},[_vm._v(_vm._s(link.description))]),_c('NbButton',{attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.redirectTo(link.path)}}},[_vm._v(_vm._s(link.buttonText))])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }